import RSelect, { IOption } from "@/component/RSelect";
import { LinkValidPeriodType } from "@/constants/share";
import dayjs from "dayjs";
interface LinkValidPeriodSelectProps {
  expiredTime?: Date;
  linkValidPeriod: LinkValidPeriodType;
  setLinkValidPeriod: (linkValidPeriod: LinkValidPeriodType) => void;
}

const LinkValidPeriodSelect = ({
  expiredTime,
  linkValidPeriod,
  setLinkValidPeriod,
}: LinkValidPeriodSelectProps) => {

  const permissionOptions: IOption[] = [
    {
      label: <div className="px-2 text-#191D26">永久</div>,
      selectLabel: <div className="text-#191D26">永久</div>,
      value: LinkValidPeriodType.Permanent,
    },
    {
      label: <div className="px-2 text-#191D26">7天</div>,
      selectLabel: <div className="text-#191D26">{`7天有效（${dayjs(expiredTime).format('MM-DD HH:mm')}）`}</div>,
      value: LinkValidPeriodType.OneWeek,
    },
    {
      label: <div className="px-2 text-#191D26">14天</div>,
      selectLabel: <div className="text-#191D26">{`14天有效（${dayjs(expiredTime).format('MM-DD HH:mm')}）`}</div>,
      value: LinkValidPeriodType.TwoWeek,
    },
    {
      label: <div className="px-2 text-#191D26">30天</div>,
      selectLabel: <div className="text-#191D26">{`30天有效（${dayjs(expiredTime).format('MM-DD HH:mm')}）`}</div>,
      value: LinkValidPeriodType.OneMonth,
    },
  ];
  return (
    <RSelect
      options={permissionOptions}
      value={linkValidPeriod}
      placement="bottomRight"
      title={
        <div className="pl-2 h-6 lh-6 text-3 text-mx-quaternary mb-1">
          链接有效期
        </div>
      }
      align={{
        offset: [0, -15],
      }}
      onChange={(value) => {
        setLinkValidPeriod(value as LinkValidPeriodType);
      }}
      contentStyleWidth="10rem"
      selectContentClassName="px-4 b-1px b-solid b-#DBDEE4"
    />
  );
};

export default LinkValidPeriodSelect;
